import React from 'react';
import { Button, ButtonGroup } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { LANGUAGES } from './StockRequestType';

const LanguageSwitcher = () => {
  const { t, i18n } = useTranslation();

  return (
    <ButtonGroup>
      {LANGUAGES.map(({ code, labelKey }) => (
        <Button
          key={code}
          type="button"
          variant={i18n.language === code ? 'primary' : 'outline-primary'}
          onClick={() => i18n.changeLanguage(code)}
        >
          {t(labelKey)}
        </Button>
      ))}
    </ButtonGroup>
  );
};

export default LanguageSwitcher;
